import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { environment } from '../../../environments/environment';
import { catchError, switchMap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ErrorModalComponent } from '../auth/error-modal/error.modal.component';
import { DestroyComponent } from '../destroy-component/destroy-component';

@Injectable()
export class AuthInterceptor extends DestroyComponent implements HttpInterceptor {
  constructor(private dialog: MatDialog) {
    super();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const backendUrls = [
      environment.authApiUrl,
      environment.apiUrl,
      environment.spApiUrl,
      environment.ppApiUrl,
      environment.cpApiUrl,
    ];

    if (backendUrls.some(url => req.url.startsWith(url))) {
      const clonedRequest = req.clone({
        withCredentials: true
      });
      return next.handle(clonedRequest).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401 || error.status === 403) {
            const errorMessage = error.status === 401 
              ? 'Your session has expired. Please log in again.'
              : 'You are not authorized to access this page.';
              
            const dialogRef = this.dialog.open(ErrorModalComponent, {
              data: { errorMessage }
            });

            return EMPTY;
          }
        })
      );
    }

    return next.handle(req);
  }
}
